import React from 'react'

import { Box } from '@material-ui/core'

import { ProductsScreenTable } from './ProductsScreenTable'

export const ProductsRoute =
  () =>
    // Margin here makes avatar in Header move around when switching tabs
    <Box className="body_wrapper_zero border_left">
      <ProductsScreenTable/>
    </Box>